import React, { useEffect, useState } from 'react'
import SubHeader from '../Shared/Display/SubHeader'
import DateTimeFilter from '../Shared/Buttons/DateTimeFilter'
// import FilterBy from '../Shared/Buttons/FilterBy'
import FilterBy from '../Shared/Filters/FilterBy'
import CustomFilter from '../Shared/Buttons/CustomFilter'
import ContentList from '../Shared/Data/ContentList'
import ContentTable from '../Shared/Data/ContentTable'
import { useDispatch, useSelector } from 'react-redux'
import { fetchTopFeedContent } from '../Redux/Actions/Content'
import { fetchImpressionStats } from '../Redux/Actions/ImpressionStats'
import { generateContentReport } from '../Redux/Actions/GenerateReport'
import { componentCreated, updateDateFilter, updateGroupFilter } from '../Redux/Actions/DateFilter'
import { getDateFilter, getGroupFilter, formatStartEndDates, processDate, processGroup, composeFilterString } from '../utils/analytics-utils'
import { addQuery } from '../utils/router-utils'
import { useLocation, useNavigate } from 'react-router'
import ImpressionStatsCards from '../Shared/Display/ImpressionStatsCards'

/** @const {number} pageTotals */
const pageTotals = 10

function NewsFeed () {
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()

  const [details, setDetails] = useState(false)
  const [page, setPage] = useState(1)
  const [sort, setSort] = useState('totalViews DESC')
  const name = 'Content'

  const id = useSelector(state => state.account.ID)
  const topViewed = useSelector(state => state.content.topFeed)
  const accountDetails = useSelector(state => state.content.accountDetails || {})
  const topViewedLength = useSelector(state => state.content.topFeedLength)
  const status = useSelector(state => state.generateReport.status)
  const dateFilterStore = useSelector(state => state.dateFilter)

  let dateFilterFromStore = getDateFilter(dateFilterStore, name)
  dateFilterFromStore = dateFilterFromStore ? dateFilterFromStore.dateFilter || 'Week' : 'Week'
  const [dateFilter, setDateFilter] = useState(dateFilterFromStore)

  const groupFilterFromStore = getGroupFilter(dateFilterStore, name) || ''
  const [groupFilter, setGroupFilter] = useState(groupFilterFromStore)
  const dateInterval = dateFilter ? dateFilter.dateInterval || null : null

  useEffect(() => {
    setDetails('feed')
  }, [])

  useEffect(() => {
    dispatch(componentCreated(name))
  }, [])

  useEffect(() => {
    update(processDate(dateFilter), processGroup(groupFilter), id)
  }, [page, sort])

  useEffect(() => {
    newQuery(location.search.substring(1).split('&'))
  }, [])

  const newQuery = (query) => {
    const qobj = {}
    let newDateFilter
    query.forEach((q) => {
      qobj[q.split('=')[0]] = q.split('=')[1]
    })
    if (dateFilter === 'Custom' && dateInterval) {
      newDateFilter = dateInterval
    } else {
      newDateFilter = dateFilter
    }
    update(processDate(newDateFilter), processGroup(groupFilter), id)
  }

  /**
   * @func update
   * @param {Object} date
   * @param {Object} group
   * @param {Object} newID
   */
  const update = (date, group, newID) => {
    const ID = newID || id
    const formattedDate = formatStartEndDates(date)
    dispatch(fetchTopFeedContent(ID, formattedDate.start, formattedDate.end, 'NEWSFEED', { group: group.groups, profile: group.profiles, limit: pageTotals, offset: (page - 1) * pageTotals, sort, appType: group.alt }))
    dispatch(fetchImpressionStats(ID, formattedDate.start, formattedDate.end, { group: group.groups, profile: group.profiles, appType: group.alt }))
  }

  const changeDateFilter = (newFilter, isCustom) => {
    if (isCustom) {
      dispatch(updateDateFilter(name, 'Custom', newFilter))
    } else {
      dispatch(updateDateFilter(name, newFilter))
    }
    const f = `${composeFilterString(groupFilter.profiles, groupFilter.groups)}_${groupFilter.alt || ''}`
    addQuery({ date: newFilter, filter: f }, location, navigate)
    setDateFilter(newFilter)
    if (newFilter !== 'Custom') {
      update(processDate(newFilter), processGroup(groupFilter))
    }
  }

  const changeGroupFilter = (newFilter) => {
    let newDateFilter
    if (dateFilter === 'Custom' && dateInterval) {
      newDateFilter = dateInterval
    } else {
      newDateFilter = dateFilter
    }

    dispatch(updateGroupFilter(name, newFilter))
    const f = `${composeFilterString(newFilter.profiles, newFilter.groups)}_${newFilter.alt || ''}`
    addQuery({ date: newDateFilter, filter: f }, location, navigate)
    setGroupFilter(newFilter)
    update(processDate(newDateFilter), processGroup(newFilter))
  }

  let content
  if (!details) {
    content = <div className='UserContent ContentContainer'>
      <div className='col1'>
        <ContentList
          groupFilter={processGroup(groupFilter)}
          data={topViewed}
          type='Views'
          location='News Feed'
          title='Top Content Viewed from News Feed'
          viewDetails={() => setDetails('feed')}
        />
      </div>
    </div>
  } else if (details === 'feed') {
    content =
      <ContentTable
        status={status}
        generateReportClick={() => {
          const dates = processDate(dateFilter)
          const group = processGroup(groupFilter)
          const options = { group: group.groups, profile: group.profiles }
          dispatch(generateContentReport(id, dates.start.toISOString(), dates.end.toISOString(), 'NEWSFEED', 'totalViewsNewsFeed', 'DESCENDING', options))
        }}
        groupFilter={processGroup(groupFilter)}
        data={topViewed}
        type='ViewsDuration'
        title='Most Viewed'
        changeOffset={(i) => {
          setPage(i)
        }}
        sort={sort}
        toggleSort={(key) => {
          if (sort.split(' ')[0] === key && sort.split(' ')[1] === 'DESC') {
            setSort(key + ' ASC')
          } else {
            setSort(key + ' DESC')
          }
        }}
        page={page}
        totalContent={Math.ceil((topViewedLength) / pageTotals)}
        accountDetails={accountDetails || {}}
      />
  }
  return (
    <div id='feedActivity'>
      <div className='toolbar'>
        {<SubHeader type='News Feed' />}
        <DateTimeFilter filterBy={changeDateFilter} currentFilter={dateFilter} />
        <div className='reportButtons'>
          {/* <FavoriteButton /> */}
          {/* <GenerateReportButton /> */}
        </div>
      </div>
      {(dateFilter !== 'Day' && dateFilter !== 'Week' && dateFilter !== 'Month') ? <CustomFilter filterBy={changeDateFilter} currentFilter={dateFilter} /> : ''}

      <FilterBy
        changeFilter={changeGroupFilter}
        showProfiles
        // showGroups
        type='App'
        currentFilter={processGroup(groupFilter)}
        dates={processDate(dateFilter)}
      />

      <ImpressionStatsCards />
      {content}
    </div>
  )
}

export default NewsFeed
